import { Tab, Tabs } from "@mui/material";
import React from "react";
import { useState } from "react";
import TabPanel from "./TabPanel";
import { v4 as uuidv4 } from "uuid";

const ReusableTabs = ({
  items,
  iframe = false,
  panelHeight = 500,
  imageProps = {
    maxWidth: "100%",
    maxHeight: "100%",
  },
}) => {
  const [tab, setTab] = useState(0);
  return (
    <React.Fragment>
      <Tabs
        value={tab}
        variant="scrollable"
        scrollButtons="auto"
        onChange={(event, newValue) => {
          setTab(newValue);
        }}
      >
        {items.map((i, idx) => (
          <Tab label={i.label} key={uuidv4()}></Tab>
        ))}
      </Tabs>
      {items.map((i, idx) => (
        <TabPanel
          key={uuidv4()}
          value={tab}
          index={idx}
          sx={{ height: panelHeight, p: 3, textAlign: "center" }}
        >
          {i?.children ? (
            i.children
          ) : iframe ? (
            <iframe
              src={`${i.src}?d=${Math.ceil(Date.now() / (1000 * 60))}`}
              height="100%"
              width="100%"
              style={{ border: 0 }}
            ></iframe>
          ) : (
            <img
              src={`${i.src}?d=${Math.ceil(Date.now() / (1000 * 60))}`}
              style={imageProps}
            />
          )}
        </TabPanel>
      ))}
    </React.Fragment>
  );
};

export default ReusableTabs;
